import { Link, createFileRoute } from '@tanstack/react-router'
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@neutrino/ui'

export const Route = createFileRoute('/_nominee/nominee-dashboard')({
  component: NomineeDashboardRoute,
})

function NomineeDashboardRoute() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className='text-2xl font-semibold'>
          Welcome, Nominee
        </CardTitle>
        <CardDescription>
          Access your claim workflows from this nominee dashboard.
        </CardDescription>
      </CardHeader>
      <CardContent className='flex flex-col gap-3 sm:flex-row'>
        <Button asChild>
          <Link to='/claims'>Submit a Claim</Link>
        </Button>
        <Button asChild variant='outline'>
          <Link to='/claims'>View My Claims</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
